export default __webpack_public_path__ + "static/media/anyni5.4202e926.jpg";